import React, { useState, useEffect, useMemo } from "react";
import AddMenuCategory from "../Component/AddMenuCategory";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Badge, Button, ButtonGroup, Col, Input, InputGroup, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import CategoryService from "../../../Services/QRCodeServices/MenuCategory/CategoryService";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import EditMenuCategory from "../Component/EditMenuCategory";

const MenuCategory = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState([]);
  const [selectedEditItem, setSelectedEditItem] = useState(null);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    //fetchData();
  };
  const toggleEditModal = () => {
    setEditModalOpen(!editModalOpen);
    //fetchData();
  };
  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
    //fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await CategoryService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Memoized value to determine if any modal just closed
  const anyModalJustClosed = useMemo(() => {
    return !editModalOpen || !modalOpen || !deleteModal;
  }, [editModalOpen, modalOpen, deleteModal]);

  useEffect(() => {
    if (anyModalJustClosed) {
      console.log("fetching data as any modal is reclosed...");
      fetchData();
    }
  }, [anyModalJustClosed]);

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await CategoryService.delete(selectedDeleteItem.id);
        setDataList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedDeleteItem.id)
        );
        toast.success("Selected Package deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedDeleteItem(null);
        fetchData();
      }
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDeleteModal();
  };

  const handleEditClick = (item) => {
    setSelectedEditItem(item);
    toggleEditModal();
  };
  const [filterText, setFilterText] = useState("");
  const filteredData = data.filter((item) => {
    const searchText = filterText.toLowerCase();
    return item?.name?.toLowerCase().includes(searchText);
  });

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => (
        <Link to={`/menu-category/detail/${row?.id}`}>{row?.name}</Link>
      ),
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) =>
        row?.cloudR2ImagePath ? (
          <img
            src={row?.cloudR2ImagePath?.getCDNUrl()} // Assuming the image is a JPEG
            alt={row?.title || "Image"}
            style={{ width: "100px", objectFit: "cover", height: "50px" }}
          />
        ) : "-",
      sortable: false,
    },
    {
      name: "Menu Type",
      selector: (row) => `${row?.menuType || "N/A"}`,
      sortable: true,
    },

    {
      name: "BOT",
      selector: (row) => `${row?.isBOT || "N/A"}`,
      cell: (row)=>(
        <Badge color={row?.isBOT ? "success": "danger"}>
          {row?.isBOT ? "true": "false"}
        </Badge>
      ),
      sortable: true,
    },

    {
      name: "KOT",
      selector: (row) => `${row?.isKOT || "N/A"}`,
      cell: (row)=>(
        <Badge color={row?.isKOT ? "success": "danger"}>
          {row?.isKOT ? "true": "false"}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-3">
          <Button
            color="warning"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => handleEditClick(row)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            onClick={() => handleDeleteClick(row)}
            style={{ width: "30px", height: "30px" }}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Menu Category List" pageTitle="Menu Category" />
      </div>
      <Row>
        <Col md={5} xs={6} className="px-xs-1">
          <InputGroup>
            <Input
              placeholder="Search by name"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col
          md={7}
          xs={6}
          className="d-flex justify-content-end align-items-end mb-3"
        >
          <Button className="package-button px-1 px-sm-2" onClick={toggleModal}>
            Add New Category
          </Button>
        </Col>
      </Row>

      <CustomDataTable
        responsive
        striped
        pagination
        fixedHeader
        persistTableHead
        progressPending={loading}
        columns={columns}
        data={filteredData}
        customStyles={{
          headCells: {
            style: {
              fontSize: "0.93rem",
              fontWeight: 610,
            },
          },
          rows: {
            style: {
              fontSize: "0.9rem",
            },
          },
        }}
        progressComponent={
          <div className="my-3">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedDeleteItem}
      />
      <AddMenuCategory
        isOpen={modalOpen}
        toggleModal={toggleModal}
        data={data}
        refreshData={fetchData}
      />
      <EditMenuCategory
        isOpen={editModalOpen}
        toggleModal={toggleEditModal}
        data={selectedEditItem}
        refreshData={fetchData}
        fullData={data}
      />
    </div>
  );
};

export default MenuCategory;
